import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'pcln-design-system'
import { BAGGAGE_FEES_TEXT, PRICE_DISCLOSURE_TEXT } from './constants'
import { PriceDisclosureContainer, LowerCaseBaggageFeesLink } from './styles'

const PriceDisclosure = ({ showBaggageFeeLink }) => (
  <PriceDisclosureContainer mb='14px' px={['16px', null, null, null, 0]}>
    <Text.span
      data-autobot-element-id='LISTINGS_PRICE_DISCLAIMER'
      fontWeight='regular'
      fontSize='10px'
      mb='10px'
    >
      {PRICE_DISCLOSURE_TEXT}
      {showBaggageFeeLink ? <LowerCaseBaggageFeesLink /> : BAGGAGE_FEES_TEXT}.
    </Text.span>
  </PriceDisclosureContainer>
)

PriceDisclosure.defaultProps = {
  showBaggageFeeLink: true,
}

PriceDisclosure.propTypes = {
  showBaggageFeeLink: PropTypes.bool,
}

export { PriceDisclosure }
